/* eslint-disable @typescript-eslint/no-use-before-define */
import {styled} from '@mui/material/styles';
import * as React from 'react';

export const ErrorMessage = styled('div')({
  fontSize: '15px',
  color: '#ff3539',
  marginBottom: '15px',
});

export function InlineError({error}: {error: string | undefined | null}) {
  if (!error) {
    return null;
  }

  return <ErrorMessage>{error}</ErrorMessage>;
}
